exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-file-name{max-width:150px}.button-file-name{display:block;width:150px;text-align:left;text-wrap:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
